// extracted by mini-css-extract-plugin
export default {"root":"LicenseBlock__root--3jFz4"};